<template>
  <div class="survey__answer survey__answer--multiple">
    <button
      v-for="(answer, index) in answers"
      :key="answer.id"
      class="survey__answer-option btn--reset"
      type="button"
      @click="() => onAnswer([answer.id])"
    >
      <span>
        {{ letters.substring(index, index + 1) }}
      </span>

      <span>
        {{ answer.answer }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true,
    },

    answers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      letters: 'abcdefghijklmnopqrstuvwxyz',
    };
  },

  methods: {
    ...mapActions([
      'onAnswer',
    ]),
  },
};
</script>
